const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const CLICK_ID_KEYS = ["gclid", "fbclid", "msclkid"];

/**
 * Campaign attribution for the current landing URL. This exact set is what we
 * send to the backend as `context` and what we attach to every waitlist
 * analytics event. It deliberately contains no personally identifying data —
 * the email address must never reach an analytics property.
 */
export const buildAttribution = () => {
  const params = new URLSearchParams(window.location.search);
  const attribution = {};

  [...UTM_KEYS, ...CLICK_ID_KEYS].forEach((key) => {
    const value = params.get(key);
    if (value) {
      attribution[key] = value;
    }
  });

  if (document.referrer) {
    attribution.referrer = document.referrer;
  }
  attribution.landingPath = `${window.location.pathname}${window.location.search}`;

  return attribution;
};

/**
 * The `context` object sent with the submission — attribution plus the
 * environment hints the backend whitelists.
 */
export const buildWaitlistContext = (attribution) => ({
  ...attribution,
  screen: `${window.screen?.width}x${window.screen?.height}`,
  viewport: `${window.innerWidth}x${window.innerHeight}`,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  language: navigator.language,
});
